import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { BookingErrorModal } from "./component";
import {
  getErrorTitles,
  getHasError,
  getIsBookingValid,
  getIsConnectionError,
  getModalType,
  getPollPriceQuoteCallState,
  getSelectedPaymentMethodId,
  getSession,
  getUserSelectedTravelerId,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import {
  scheduleBook,
  schedulePriceQuote,
  acknowledgePriceDifference,
  markConnectionRetryPending,
  resetBookErrors,
} from "../../actions/actions";
import {
  getAdultsCount,
  getChildrenCount,
  getFromDate,
  getUntilDate,
} from "../../../search/reducer";
import { getPremierCollectionShopSelectedAvailability } from "../../../shop/reducer/selectors";
import { CallState } from "redmond";
import { getAllAncillaries } from "../../../ancillary/reducer";

const mapStateToProps = (state: IStoreState) => ({
  hasError: getHasError(state),
  errorTitles: getErrorTitles(state),
  paymentMethodId: getSelectedPaymentMethodId(state),
  currentSession: getSession(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  lodging: getPremierCollectionShopSelectedAvailability(state),
  childrenCount: getChildrenCount(state),
  adultsCount: getAdultsCount(state),
  isBookingValid: getIsBookingValid(state),
  priceQuoteSuccessful: getPollPriceQuoteCallState(state) === CallState.Success,
  modalType: getModalType(state),
  ancillaries: getAllAncillaries(state),
  isConnectionError: getIsConnectionError(state),
});

const mapDispatchToProps = {
  scheduleBook,
  schedulePriceQuote,
  resetBookErrors,
  acknowledgePriceDifference,
  markConnectionRetryPending,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type BookingErrorModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedBookingErrorModal = withRouter(
  connector(BookingErrorModal)
);
